import { Sensitivity } from 'lib/models/diagnoses/choices/sensitivity';
import React, { HTMLProps, useMemo } from 'react';

type SensitivitySelectorProps = {
  id?: string;
  name?: string;
  value: Sensitivity | undefined;
  required?: boolean;
  tabIndex?: number;
  onChange: (sensitivity: Sensitivity | undefined) => void;
} & Omit<HTMLProps<HTMLSelectElement>, 'onChange' | 'value'>;

export const SensitivitySelector: React.FC<SensitivitySelectorProps> = ({
  value,
  onChange,
  ...props
}) => {
  // Available choices for sensitivitys
  const sensitivitysList = useMemo(
    () => [
      // Only valid sensitivitys listed
      ...Sensitivity.values()
        .map((sensitivity) => ({
          sensitivity,
          label: sensitivity.label
        }))
        .reverse()
    ],
    ['sensitivity choices']
  );

  return (
    <select
      {...props}
      value={value !== undefined ? value.id : -99}
      onChange={(e) => {
        const input = parseInt(e.target.value, 10);
        if (input === -99) {
          onChange(undefined);
        } else {
          onChange(Sensitivity.fromId(input));
        }
      }}
    >
      {sensitivitysList.map(({ sensitivity, label }) => (
        <option
          key={sensitivity !== undefined ? sensitivity.id : -99}
          value={sensitivity !== undefined ? sensitivity.id : -99}
        >
          {label}
        </option>
      ))}
    </select>
  );
};
